import React from "react";

import clsx from "clsx";
import Image from "next/image";

import integrationsList from "./integrations-list";
import useRandomAnimation from "./use-random-animation";

export const xPlacementOffset = 0.2;
export const itemSize = 100;
export const totalLength = integrationsList.length * (itemSize * xPlacementOffset);
export const threshold = 5;
const imageSize = 141;

type Props = {
  integration: string;
  row: number;
  animate?: boolean;
};

const Item = ({ integration, row, animate }: Props) => {
  const itemClass = `item-${row}-${integration}`;
  const animationClass = useRandomAnimation(animate);

  return (
    <div className={clsx("random-animation", itemClass, animationClass)} title={integration}>
      <Image
        src={`/images/logos/${integration}.svg`}
        alt={`${integration} logo`}
        height={`${imageSize}px`}
        width={`${imageSize}px`}
        loading="eager"
      />
    </div>
  );
};

export default Item;
